<!-- <div class="filter"></div> -->

<div class="d-flex flex-row-reverse">

  <div class="d-flex flex-column justify-content-center bg-white" style="position: relative;width: 100%;height: 330px">
    <div class="d-flex justify-content-center">
      <i class="bi bi-search" style="font-size: 38px;"></i>
    </div>
    <div>
      <p class="mb-0 title">Buscando</p>
      <p class="mb-0 title">{{getCategorySearching()}} en:</p>
    </div>
    <div class="mt-4 mx-auto" style="max-width: 180px;">
        <p *ngIf="category === 1" class="mb-0 destination">{{formData.destination?.city_name}} ({{formData.destination?.country_iata_code}})</p>
        <p *ngIf="category === 2" class="mb-0 destination">{{formData.origin?.city_name || formData.origin?.name}} ({{formData.origin?.country_iata_code || formData.origin?.iata}})</p>
        <p *ngIf="category === 3" class="mb-0 destination">{{formData.origin?.name}} ({{formData.origin?.iata}})</p>
        <p *ngIf="category === 6" class="mb-0 destination">{{formData.destination?.city_name}} ({{formData.destination?.country_iata_code}})</p>
        <p *ngIf="category === 8" class="mb-0 destination">{{formData.firstOrigin.city_name || formData.firstOrigin.name || formData.firstOrigin.hotel_name || formData.firstOrigin.display}} ({{data.transfers.pickupLocation.origin}})</p>
        <p *ngIf="category === 9" class="mb-0 destination">{{formData.destination?.city_name}} ({{formData.destination?.country_iata_code}})</p>
        <p *ngIf="category === 10" class="mb-0 destination">{{formData.destination.label}}</p>
    </div>
    <div class="mt-4">
      <div>
        <p *ngIf="category === 1" class="mb-0 date">Desde: {{ data.arrivalDate || formData.dateStarEnd.start | date:'dd/MM/yyyy' }} hasta: {{data.departureDate || formData?.dateStarEnd?.end | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 2" class="mb-0 date">Desde: {{data.arrivalDate | date:'dd/MM/yyyy' }} hasta: {{data.departureDate | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 3" class="mb-0 date">Partida: {{data.arrivalDate | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 6" class="mb-0 date">Desde: {{formData.arrivalDateDepartureDate.start | date:'dd/MM/yyyy'}} hasta: {{formData.arrivalDateDepartureDate.end | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 8" class="mb-0 date">Desde: {{formData.firstArrivalDate | date: 'dd/MM/yyyy'}} hasta: {{(formData.secondArrivalDate ? formData.secondArrivalDate : formData.firstArrivalDate) | date: 'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 9" class="mb-0 date">Desde: {{formData.arrivalDateDepartureDate.start | date:'dd/MM/yyyy'}} hasta: {{formData.arrivalDateDepartureDate.end | date:'dd/MM/yyyy'}}</p>
        <p *ngIf="category === 10" class="mb-0 date">Desde: {{formData.beginDateEndDate.start | date:'dd/MM/yyyy'}} hasta: {{formData.beginDateEndDate.end | date:'dd/MM/yyyy'}}</p>
      </div>
      <div>
        <p *ngIf="category === 1" class="mb-0 product-configuration">Habitaciones {{data? data.qtyProduct : '' }} | {{adults }} {{ adults == 1 ?   'Adulto' : 'Adultos'  }}  {{validateChildren(children)}} </p>
        <p *ngIf="category === 2" class="mb-0 product-configuration">Edad del conductor: {{formData.age}} años </p>
        <p *ngIf="category === 2 && ageDriver >= 21 && ageDriver <=24" class="mb-0 product-configuration">Algunas compañías podrían aplicar cargos extras en destino si el conductor tiene entre 21 y 24 años.</p>
        <p *ngIf="category === 6" class="mb-0 product-configuration">Adultos {{formData.qtyAdults }} | Niños {{formData.qtyChilds}}</p>
        <p *ngIf="category === 8" class="mb-0 product-configuration">Vehículos 1 | Adultos {{ adults }} | Niños {{ children }} </p>
        <p *ngIf="category === 9" class="mb-0 product-configuration">Adultos {{formData.qtyAdults }} | Niños {{formData.qtyChilds}}</p>
        <p *ngIf="category === 10" class="mb-0 product-configuration">{{formData.qtyPax }} {{formData.qtyPax === 1 ? 'Pasajero' : 'Pasajeros'}} | {{formData.serviceType}}</p>
      </div>

    </div>


  </div>
  <div style="width: 50%; height: 330px; flex-shrink: 0;" *ngIf="!imgZone">
            <img style="width: 100%; height: 100%; object-fit: cover;"
                [src]="agencyImagen"
                alt="">
  </div>
  <div style="width: 50%; height: 330px; flex-shrink: 0;" *ngIf="imgZone">

    <div style="width: 100%; height: 100%;">
      <owl-carousel-o
                     [options]="customOptionsModalLoading"
                     #owlElement
                     style="width: 100%; height: 100%;">
      <ng-container *ngFor="let slide of imgZonesArr" >
        <ng-template carouselSlide>
          <div style="width: 100%; height: 330px;">
            <img style="width: 100%; height: 100%; object-fit: cover;"
                [src]="slide"
                alt="">
          </div>
        </ng-template>

      </ng-container>

      </owl-carousel-o>
    </div>
  </div>
</div>


<!-- <div class="d-flex flex-column-reverse">
  <div class="d-flex flex-column bg-white" style="position: relative;overflow: hidden;">
    <div class="row d-flex justify-content-center">
      <div class="col-12 d-flex justify-content-around">
      </div>
    </div>
    <br>
    <div class="loader mx-auto" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"> Buscando {{ (tabNameOrig) }} en
    </div>
    <div class="d-flex flex-column my-3">
      <div *ngIf="data.categoriesId[0] === 1" class="d-flex flex-row justify-content-center align-items-end mb-2">

        <p class="destination ml-2 m-0">{{ formData && formData.destination ? formData.destination.cityName : '' }} </p>
      </div>


      <div *ngIf="data.categoriesId[0] === 8" class="d-flex flex-column mb-2">
              <div *ngIf=" formData"  class="d-flex flex-column mb-2">
                <p class="destination mb-1" style="line-height: 1; font-size: 14px !important">pickup:&nbsp;&nbsp;{{ extractNameTransport(formData?.firstOrigin, 'origin')}} </p>
                <p class="destination m-0" style="line-height: 1; font-size: 14px !important">dropoff: {{ extractNameTransport(formData?.firstDestination , 'destination')}} </p>
            </div>
          <p  class="date m-0">
            <span style="font-weight: bold; font-size: 12px;">
              Inicio:<span *ngIf="data?.transfers?.dropoffTime">&nbsp;&nbsp;&nbsp;&nbsp;</span>{{ data.pickupDate | date:'dd/MM/yyyy' }} ({{data?.transfers?.pickupTime}} hs. - {{getMessageFirstTime( data.transfers.pickupLocation, 'origin')}})
            </span>
          </p>
          <p *ngIf="data?.transfers?.dropoffTime"  class="date m-0">
            <span style="font-weight: bold; font-size: 12px;">
              Vuelta: {{data.dropoffDate | date:'dd/MM/yyyy'}} ({{data?.transfers?.dropoffTime}} hs. - {{getMessageFirstTime( data.transfers.dropoffLocation, 'destination')}})
            </span>
          </p>

          <div class="d-flex flex-row justify-content-center align-items-end mb-2 mt-2">
        <p class="detail ml-2 m-0">
            Vehículos 1 | Adultos {{ adults }} | Niños {{ children }} </p>
      </div>
      </div>
      <div class="d-flex flex-row justify-content-center align-items-end mb-2" *ngIf="data.categoriesId[0] == 1" >
        <p class="detail ml-2 m-0">
           {{formData.destination.city_name }} ({{formData.destination.country_iata_code}}) </p>
      </div>

      <div *ngIf="data.categoriesId[0] === 1" class="d-flex flex-row justify-content-center align-items-end mb-2">
          <p *ngIf="data.categoriesId[0] === 1" class="date ml-2 m-0"><span class="text-uppercase"></span>Desde
            <span style="font-weight: bold; font-size: 12px;">
              {{ data.arrivalDate || formData.dateStarEnd.start | date:'dd/MM/yyyy' }},
            </span>
            Hasta
            <span style="font-weight: bold; font-size: 12px;">
              {{data.departureDate || formData?.dateStarEnd?.end | date:'dd/MM/yyyy'}}
            </span>
          </p>
      </div>

      <div class="d-flex flex-row justify-content-center align-items-end mb-2" *ngIf="data.categoriesId[0] == 1" >
        <p class="detail ml-2 m-0">
            Habitaciones {{data? data.qtyProduct : '' }} | {{adults }} {{ adults == 1 ?   'ADULTO' : 'ADULTOS'  }}  {{validateChildren(children)}} </p>
      </div>


      <div class="d-flex flex-column justify-content-center" *ngIf="data.categoriesId[0] == 6" >
        <p class="detail ml-2 m-0">
          {{formData.destination.city_name }} ({{formData.destination.country_iata_code}})
        </p>
        <p class="detail ml-2 m-0" style="font-size: 12px;">
          Desde
          <span style="font-weight: bold; font-size: 12px;">
            {{formData.arrivalDateDepartureDate.start | date:'dd/MM/yyyy'}}
          </span>
          , Hasta
          <span style="font-weight: bold; font-size: 12px;">
            {{formData.arrivalDateDepartureDate.end | date:'dd/MM/yyyy'}}
          </span>
        </p>
         <p class="detail ml-2 m-0" style="font-size: 12px;">
          Adultos {{formData.qtyAdults }} | Niños {{formData.qtyChilds}}
        </p>
      </div>


      <div class="d-flex flex-column justify-content-center" *ngIf="data.categoriesId[0] == 9" >
        <p class="detail ml-2 m-0">
          {{formData.destination.city_name }} ({{formData.destination.country_iata_code}})
        </p>
        <p class="detail ml-2 m-0" style="font-size: 12px;">
          Desde
          <span style="font-weight: bold; font-size: 12px;">
            {{formData.arrivalDateDepartureDate.start | date:'dd/MM/yyyy'}}
          </span>
          , Hasta
          <span style="font-weight: bold; font-size: 12px;">
            {{formData.arrivalDateDepartureDate.end | date:'dd/MM/yyyy'}}
          </span>
        </p>
         <p class="detail ml-2 m-0" style="font-size: 12px;">
          Adultos {{formData.qtyAdults }} | Niños {{formData.qtyChilds}}
        </p>
      </div>


      <div class="d-flex flex-column justify-content-center" *ngIf="data.categoriesId[0] == 2" >
        <span style="font-weight: bold; font-size: 12px;" class="detail ml-2 m-0">
            Lugar de recogida
        </span>
        <p class="detail ml-2 m-0">
          {{formData.origin.city_name || formData.origin.name }} ({{formData.origin.country_iata_code || formData.origin.country_code}})
        </p>
        <p class="detail ml-2 m-0">
          {{data.arrivalDate | date:'dd/MM/yyyy' }} - {{data.departureDate | date:'dd/MM/yyyy'}}
        </p>
      </div>
      <div class="d-flex flex-column justify-content-center" *ngIf="data.categoriesId[0] == 2" >
        <p class="detail ml-2 m-0">
          {{formData.hourOrigin}} - {{formData.hourDestination}}
        </p>
      </div>
      <div class="d-flex flex-column justify-content-center" *ngIf="data.categoriesId[0] == 2" >
          <p class="detail ml-2 m-0" style="font-size: 12px;" *ngIf="ageDriver >= 21 && ageDriver <=24" >
            Algunas compañías podrían aplicar cargos extras en destino si el conductor tiene entre 21 y 24 años.
          </p>
        </div>


        <div class="d-flex flex-column justify-content-center" *ngIf="data.categoriesId[0] == 10" >
        <p class="detail ml-2 m-0">
          Destino: {{formData.destination }}
        </p>
        <p class="detail ml-2 m-0" style="font-size: 12px;">
          Desde
          <span style="font-weight: bold; font-size: 12px;">
            {{formData.beginDateEndDate.start | date:'dd/MM/yyyy'}}
          </span>
          , Hasta
          <span style="font-weight: bold; font-size: 12px;">
            {{formData.beginDateEndDate.end | date:'dd/MM/yyyy'}}
          </span>
        </p>
         <p class="detail ml-2 m-0" style="font-size: 12px;">
           {{formData.qtyPax }} {{formData.qtyPax === 1 ? 'Pasajero' : 'Pasajeros'}} | {{formData.serviceType}}
        </p>
      </div>

    </div>
  </div>


</div> -->
